import { Breadcrumbs } from "@similarweb/ui-components";

import { onCrumbClick } from "app/pages/activation/helpers/onBreadcrumbClick";
import { translate } from "app/filters/i18nFilter";
import { headerDataAutomation } from "app/pages/activation/components/Header/dataAutomationKeys";
import { ACTIVATION_HOME_ROUTE } from "app/pages/activation/routing/constants";
import { HOMEPAGE_TEXT } from "app/pages/activation/services/constants";

type ProjectBreadcrumbsSchema = {
    isLoading: boolean;
    currentCrumbTitle: string;
};

export const ProjectBreadcrumbs = ({ isLoading, currentCrumbTitle }: ProjectBreadcrumbsSchema) => {
    const crumbsList = [
        {
            state: ACTIVATION_HOME_ROUTE,
            title: translate(HOMEPAGE_TEXT),
        },
        {
            state: "",
            title: currentCrumbTitle,
        },
    ];

    return (
        <Breadcrumbs
            isLoading={isLoading}
            list={crumbsList}
            onClick={onCrumbClick}
            dataAutomation={headerDataAutomation.breadcrumbs}
        />
    );
};
